export default {
    common: {
        select: 'Select',
        loading: 'Loading',
        qty: 'QTY'
    },
    //component
    wineSelect: {
        title: 'Would you like to change your wine?',
        intro: 'Details',
        default: 'Default'
    },
    addOnsSelect: {
        title: 'Would you like to add more goodies?',
        intro: 'Details',
        placeholder: 'Please Select',
    },
    messageInput: {
        'your_browser_does_not_support_this_feature': 'Your browser does not support this feature.',
        'message_input_type_1_title': 'Quick Input',
        'message_input_type_1_description': 'Generic Format',
        'message_input_type_2_title' : 'Input and edit your message card here',
        'message_input_type_2_description': 'Custom Format',
        'message_overflow_warning': 'Overflow of content is detected. Part of the content may not be able to display. If all content display properly, you can ignore this message.'
    },
    //store
    cart: {
        itemAddOnOrModification: 'Revised or added item(s)',
        viewCart: 'View cart',
    }
}